import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'radio-selection-button',
    templateUrl: './radio-selection-button.component.html',
    styleUrls: ['./radio-selection-button.component.scss']
})
export class RadioSelectionButton {

    @Input() valueId: number;
    @Input() valueName: string;
    @Input() name: string;

    /** Несколько значений, внешний вид как у обычных кнопок; выбранность задаётся через isSelected */
    @Input() multiSelect: boolean = false;
    @Input() isSelected: boolean = false;

    private _id: number;
	public get id(): number{
		return this._id;
	}
	@Input()
	public set id(value: number) {
		this._id = value;
        this.idChange.emit(value);
	}

    @Output() idChange: EventEmitter<number> = new EventEmitter<number>();
    @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();
    @Output() toggleSelect: EventEmitter<number> = new EventEmitter<number>();

    changeValueId() {
        this.valueChange.emit(this.valueId);
    }

    onMultiToggle(event: MouseEvent) {
        if (event) {
            event.preventDefault();
        }
        this.toggleSelect.emit(this.valueId);
    }
}